/**
 * @file nsSteps.js
 *
 * JQuery steps initialization for Numbered sequence paragraph and
 * calling functions for custom slider "stepsSlider".
 */
import stepsSlider from "./nsSlider";
import debounce from "../common/debounce";

const $ = window.jQuery;
const STEP_HEADER_TAG = 'h6';
const STEP_BODY_TAG = 'section';

export default {
  attach: function (context, settings) {
    const nsSteps_once = once('ifm-ns-steps', '.numbered-sequence-steps', context);

    if($(nsSteps_once).length) {
      nsSteps_once.forEach(function(steps, index) {
        let $steps = $(steps);

        // Call init function.
        Drupal.behaviors.nsSteps.initSteps($steps, settings, context);
      });
    }
  },

  /**
   * Init steps.js
   * @param $steps
   * @param settings
   * @param context
   */
  initSteps: function($steps, settings, context) {
    let that = this;
    let $_BUTTON_NEXT = $('<button></button>')
      .addClass('slider-next')
      .attr('tabindex', 0)
      .attr('aria-label', Drupal.t('next'));
    let $_BUTTON_PREV = $('<button></button>')
      .addClass('slider-prev')
      .attr('tabindex', 0)
      .attr('aria-label', Drupal.t('previous'));
    let $paragraphWrapper = $steps.parent().parent();
    let paragraphId = $paragraphWrapper.attr('data-drupal-id');
    let urifm_ns_settings = settings.urifm_ns_steps[paragraphId];
    let icons = [];
    let use_icons = urifm_ns_settings.use_icons;
    let titleTemplate = '<span class="step">#index#</span> #title#';

    // Call custom slider.
    let stepsSlider_class = new stepsSlider();
    that[paragraphId] = stepsSlider_class;

    // Change the template if icons are used instead of numbers.
    if (use_icons) {
      icons = urifm_ns_settings.icons;
      titleTemplate = '<span class="step"> </span> #title#';
    }

    // Initialize steps plugin and define actions.
    $steps.steps({
      headerTag: STEP_HEADER_TAG,
      bodyTag: STEP_BODY_TAG,
      transitionEffect: "fade",
      enablePagination: true,
      suppressPaginationOnFocus: true,
      enableAllSteps: true,
      enableFinishButton: false,
      titleTemplate: titleTemplate,
      labels: {
        next: "<i class=\"fas fa-arrow-right\"></i>",
        previous: "<i class=\"fas fa-arrow-left\"></i>"
      },

      /**
       * Steps onInit
       * @param event
       * @param currentIndex
       */
      onInit: function (event, currentIndex) {
        // Initialize the slider.
        stepsSlider_class.setSteps($steps.find('.steps'));
        // Inactive prv btn on load.
        $_BUTTON_PREV.addClass('inactive');
        $_BUTTON_PREV.attr('tabindex', -1);

        // Set buttons.
        $steps.find('.steps').prepend($_BUTTON_PREV);
        $steps.find('.steps').append($_BUTTON_NEXT);

        // add icons to the numbered sequence.
        if (use_icons) {
          $steps.find('span.step').each(function (index, element){
            $(element).addClass(icons[index]['style']);
            $(element).addClass('fa-' + icons[index]['name']);
          });
        }

        // Add icon/number to indicate step in PRINT version.
        $steps.find('h6 .field--name-field-step-title').each(function(index, element){
          let iconClass = use_icons ? icons[index]['style'] : 'numbers';
          let iconStyleClass = use_icons ? 'fa-' + icons[index]['name'] : '';
          let $span = $('<span></span>')
            .addClass('print-icon-step')
            .addClass(iconClass)
            .addClass(iconStyleClass);

          // If numbers are used set text.
          if(!use_icons) {
            $span.text(index + 1);
          }

          // Insert span before h6 element.
          $span.insertBefore($(element));
        });
        // Reinitialize the slider.
        stepsSlider_class.setSteps($steps.find('.steps'));
      },

      /**
       * Steps onChanged.
       * @param event
       * @param currentIndex
       * @param priorIndex
       */
      onStepChanged: function (event, currentIndex, priorIndex) {
        let count = $steps.find('ul[role="tablist"] li').length;

        // Calling custom slider slideChange function.
        stepsSlider_class.activeSlideChange(currentIndex, priorIndex);

        if ($steps.steps('getCurrentIndex') > 0) {
          $_BUTTON_PREV.removeClass('inactive');
          $_BUTTON_PREV.attr('tabindex', 0);
        }
        else {
          $_BUTTON_PREV.addClass('inactive');
          $_BUTTON_PREV.attr('tabindex', -1);
        }

        if ($steps.steps('getCurrentIndex') < count - 1) {
          $_BUTTON_NEXT.removeClass('inactive');
          $_BUTTON_NEXT.attr('tabindex', 0);
        }
        else {
          $_BUTTON_NEXT.addClass('inactive');
          $_BUTTON_NEXT.attr('tabindex', -1);
        }
      }
    });

    // Debounce function.
    let debounceResize = debounce(function () {
      /**
       * For steps slider (generate fresh one)
       */
      let $steps = $('.steps', context);
      if ($steps.length) {
        $steps.each(function (index, item) {
          // Call steps slider from settings and redefine steps elements.
          let paragraphId = $(item)
            .parent()
            .parent()
            .parent()
            .attr('data-drupal-id');

          that[paragraphId].setSteps($(item), true);
        });
        // Adding another function here!
      }
    }, 250);

    // On window resize.
    $(window).resize('resize', debounceResize);

    // Disable dblclick events.
    $_BUTTON_NEXT.unbind("dblclick");
    $_BUTTON_PREV.unbind("dblclick");

    // Click on prev BTN.
    $_BUTTON_PREV.on('click', function () {
      let $btn = $(this);
      $btn.attr('disabled', 'disabled');
      $steps.steps('previous');

      // Enable arrow.
      setTimeout(function (){
        $btn.removeAttr('disabled');
      }, 500);
    });

    // Click on next BTN.
    $_BUTTON_NEXT.on('click', function () {
      let $btn = $(this);
      $btn.attr('disabled', 'disabled');
      $steps.steps('next');

      // Enable arrow.
      setTimeout(function (){
        $btn.removeAttr('disabled');
      }, 500);
    });
  },
}
